import {signal} from "@preact/signals-react";

export const productPagesKpiIsEmpty = signal(false)
export const kpiSelected = signal('')
export const evolutionDataFilters = signal({})
export const evolutionSelection = signal('')
export const evolutionCurrentPeriod = signal("")
export const productPagesKpiEndDate = signal("")

export const productPageKpiFilters = signal([])
export const productPagesKpiReportFormIsOpen = signal(false)
export const productPagesKpiSubmittedFilters = signal({})